import * as yup from 'yup';

export const addStoreValidation = yup.object({
  name: yup.string().required('*required'),
  type: yup.string().required('*required'),
  agent: yup.object({ name: yup.string().required('*required') }),
  state: yup.string().required('*required'),
  address: yup.object({ address: yup.string().required('*required') })
});
export const editStoreValidation = yup.object({
  name: yup.string(),
  type: yup.string(),
  state: yup.string(),
  address: yup.object({ address: yup.string() })
});
export const addProductValidation = yup.object({
  name: yup.string().required('*required'),
  price: yup.string().required('*required'),
  stock: yup.string().required('*required'),
  description: yup.string().required('*required'),
  category: yup.object({
    name: yup.string().required('*required')
  })
});
export const editProductValidation = yup.object({
  name: yup.string(),
  price: yup.string(),
  stock: yup.string(),
  description: yup.string(),
  category: yup.object({
    name: yup.string()
  })
});
